import { ColorPalette } from '../shared/model/color-palette.model';
import { TranslatableString } from '../shared/model/translateble-string.model';

export class Transcript {
    constructor(
        public transcriptDetail?: TranscriptDetail[],
        public totalCredit?: number,
        public creditEarned?: number,
        public averageInPercent?: number,
        public gradePointAverage?: number,
        public creditSystemEnabled?: boolean,
        public weightedAverageInPercent?: number,
        public weightedGradePointAverage?: number
    ) {
        this.transcriptDetail = transcriptDetail ? transcriptDetail : [];
        this.totalCredit = totalCredit ? totalCredit : 0;
        this.creditEarned = creditEarned ? creditEarned : 0;
        this.averageInPercent = averageInPercent ? averageInPercent : 0;
        this.gradePointAverage = gradePointAverage ? gradePointAverage : 0;
        this.weightedAverageInPercent = weightedAverageInPercent ? weightedAverageInPercent : 0;
        this.weightedGradePointAverage = weightedGradePointAverage ? weightedGradePointAverage : 0;
        this.creditSystemEnabled = creditSystemEnabled ? creditSystemEnabled : false;
    }
}

export class TranscriptWithSubject {
    constructor(
        public transcriptSubjectDetail?: TranscriptSubjectDetail[],
        public creditEarned?: number,
        public creditAttempted?: number,
        public creditSystemEnabled?: boolean,
        public gradePointAverage?: number,
        public averageInPercent?: number
    ) {
        this.transcriptSubjectDetail = transcriptSubjectDetail ? transcriptSubjectDetail : [];
        this.creditEarned = creditEarned ? creditEarned : 0;
        this.creditAttempted = creditAttempted ? creditAttempted : 0;
        this.creditSystemEnabled = creditSystemEnabled ? creditSystemEnabled : false;
        this.gradePointAverage = gradePointAverage ?? null;
        this.averageInPercent = averageInPercent ?? null;
    }
}
export class TranscriptDetail {
    constructor(
        public academicPeriodName?: string,
        public translateAcademicPeriodName?: TranslatableString[],
        public semesterName?: string,
        public translateSemesterName?: TranslatableString[],
        public quarterName?: string,
        public translateQuarterName?: TranslatableString[],
        public transcriptGradeDetail?: TranscriptGradeDetail[],
        public totalCredit?: number,
        public periodAverageInPercent?: number,
        public periodPointAverage?: number,
        public gradeAverageInPercent?: number,
        public gradePointAverage?: number,
        public classGrade?: string,
        public studentClass?: string,
        public creditAttempted?: number,
        public creditEarned?: number,
        public weightedPeriodAverageInPercent?: number,
        public weightedPeriodPointAverage?: number,
        public weightedGradeAverageInPercent?: number,
        public weightedGradePointAverage?: number
    ) {
        this.classGrade = classGrade ?? null;
        this.studentClass = studentClass ?? null;
        this.academicPeriodName = academicPeriodName ? academicPeriodName : null;
        this.translateAcademicPeriodName = translateAcademicPeriodName ? translateAcademicPeriodName : [];
        this.semesterName = semesterName ? semesterName : null;
        this.translateSemesterName = translateSemesterName ? translateSemesterName : [];
        this.quarterName = quarterName ? quarterName : null;
        this.translateQuarterName = translateQuarterName ? translateQuarterName : [];
        this.transcriptGradeDetail = transcriptGradeDetail ? transcriptGradeDetail : [];
        this.totalCredit = totalCredit ? totalCredit : 0;
        this.periodAverageInPercent = periodAverageInPercent ? periodAverageInPercent : 0;
        this.periodPointAverage = periodPointAverage ? periodPointAverage : 0;
        this.gradeAverageInPercent = gradeAverageInPercent ? gradeAverageInPercent : 0;
        this.gradePointAverage = gradePointAverage ? gradePointAverage : 0;
        this.creditAttempted = creditAttempted ? creditAttempted : 0;
        this.creditEarned = creditEarned ? creditEarned : 0;
        this.weightedPeriodAverageInPercent = weightedPeriodAverageInPercent ? weightedPeriodAverageInPercent : 0;
        this.weightedPeriodPointAverage = weightedPeriodPointAverage ? weightedPeriodPointAverage : 0;
        this.weightedGradeAverageInPercent = weightedGradeAverageInPercent ? weightedGradeAverageInPercent : 0;
        this.weightedGradePointAverage = weightedGradePointAverage ? weightedGradePointAverage : 0;
    }
}

export class TranscriptSubjectDetail {
    constructor(
        public subjectName?: string,
        public translateSubjectName?: TranslatableString[],
        public subjectCss?: ColorPalette,
        public transcriptSubjectGradeDetail?: TranscriptSubjectGradeDetail[],
        public creditEarned?: number,
        public creditAttempted?: number
    ) {
        this.subjectName = subjectName ? subjectName : null;
        this.translateSubjectName = translateSubjectName ? translateSubjectName : [];
        this.subjectCss = subjectCss ? subjectCss : null;
        this.transcriptSubjectGradeDetail = transcriptSubjectGradeDetail ? transcriptSubjectGradeDetail : [];
        this.creditEarned = creditEarned ? creditEarned : 0;
        this.creditAttempted = creditAttempted ? creditAttempted : 0;
    }
}
export class TranscriptGradeDetail {
    constructor(
        public courseName?: string,
        public translateCourseName?: TranslatableString[],
        public courseCode?: string,
        public credit?: number,
        public percentOfGrade?: number,
        public letterGrade?: string,
        public gradeCss?: ColorPalette,
        public point?: number,
        public gradeDecription?: string
    ) {
        this.courseName = courseName ? courseName : null;
        this.translateCourseName = translateCourseName ? translateCourseName : [];
        this.courseCode = courseCode ? courseCode : null;
        this.credit = credit ? credit : 0;
        this.percentOfGrade = percentOfGrade ? percentOfGrade : 0;
        this.letterGrade = letterGrade ? letterGrade : '';
        this.gradeCss = gradeCss ? gradeCss : null;
        this.point = point ? point : 0;
        this.gradeDecription = gradeDecription ? gradeDecription : '';
    }
}
export class TranscriptSubjectGradeDetail {
    constructor(
        public courseName?: string,
        public translateCourseName?: TranslatableString[],
        public academicPeriodName?: string,
        public translateAcademicPeriodName?: TranslatableString[],
        public semesterName?: string,
        public translateSemesterName?: TranslatableString[],
        public quarterName?: string,
        public translateQuarterName?: TranslatableString[],
        public courseCode?: string,
        public credit?: number,
        public percentOfGrade?: number,
        public letterGrade?: string,
        public gradeCss?: ColorPalette,
        public point?: number,
        public gradeDecription?: string,
        public translateGradeDecription?: TranslatableString[],
        public gradeRangeType?: string,
        public excludeFromTranscript?: boolean,
        public excludeFromGPA?: boolean
    ) {
        this.courseName = courseName ? courseName : '';
        this.translateCourseName = translateCourseName ? translateCourseName : [];
        this.academicPeriodName = academicPeriodName ? academicPeriodName : '';
        this.translateAcademicPeriodName = translateAcademicPeriodName ? translateAcademicPeriodName : [];
        (this.semesterName = semesterName ? semesterName : ''),
            (this.translateSemesterName = translateSemesterName ? translateSemesterName : []),
            (this.quarterName = quarterName ? quarterName : ''),
            (this.translateQuarterName = translateQuarterName ? translateQuarterName : []),
            (this.courseCode = courseCode ? courseCode : '');
        this.credit = credit ? credit : 0;
        this.percentOfGrade = percentOfGrade ? percentOfGrade : 0;
        this.letterGrade = letterGrade ? letterGrade : '';
        this.gradeCss = gradeCss ? gradeCss : null;
        this.point = point ? point : 0;
        this.gradeDecription = gradeDecription ? gradeDecription : '';
        this.translateGradeDecription = translateGradeDecription ? translateGradeDecription : [];
        this.gradeRangeType = gradeRangeType ? gradeRangeType : 'PASS';
        this.excludeFromTranscript = excludeFromTranscript ? excludeFromTranscript : false;
        this.excludeFromGPA = excludeFromGPA ? excludeFromGPA : false;
    }
}

export class DemormalisedSubjectGradeDetail extends TranscriptSubjectGradeDetail {
    constructor(
        public subjectIndexId: number, // for demormalisation
        public order: number // for demormalisation
    ) {
        super();
        this.subjectIndexId = subjectIndexId ? subjectIndexId : null;
        this.order = order ? order : null;
    }
}

export const TranscriptType = {
    STUDENT_TRANSCRIPT_BY_ACADEMIC_YEAR: 'STUDENT_TRANSCRIPT_BY_ACADEMIC_YEAR',
    STUDENT_TRANSCRIPT_BY_SUBJECT: 'STUDENT_TRANSCRIPT_BY_SUBJECT',
} as const;
export type TranscriptType = (typeof TranscriptType)[keyof typeof TranscriptType];

export interface TranscriptTypes {
    type: TranscriptType;
    viewValue: string;
}

export const GPACalculationType = {
    RECALCULATE_GPA: 'RECALCULATE_GPA',
    USE_PRECALCULATED_GPA: 'USE_PRECALCULATED_GPA',
} as const;
export type GPACalculationType = (typeof GPACalculationType)[keyof typeof GPACalculationType];

export interface GPACalculationTypes {
    type: GPACalculationType;
    viewValue: string;
}
